import './modules/app-utils';
 
import * as bootstrap from "bootstrap";
global.bootstrap = bootstrap;

import Header from "./modules/header";
import Introduction from "./modules/introduction";
import Highlights from "./modules/highlights";
import Strategy from "./modules/strategy";
import Governance from "./modules/governance";
import Keyfigures from "./modules/keyfigures";

window.addEventListener('load', () => {
    document.body.classList.add('css-animation-ready'); // Wait for the DOM to be fully loaded (with fonts), to run animations (wrong width if font not loaded for example)
})

window.initAnims = true;

app.domReady(() => {
    
    const els = {
        _introduction: document.querySelectorAll('.js-introduction'),
        _highlights: document.querySelectorAll('.js-highlights'),
        _strategy: document.querySelectorAll('.js-strategy'),
        _governance: document.querySelectorAll('.js-governance'),
        _keyfigures: document.querySelectorAll('.js-keyfigures'),
    };
    
    new Header();

    if(els._introduction.length){
        [...els._introduction].map((el) => {
            new Introduction(el);
        });
    }
    
    if(els._highlights.length){
        [...els._highlights].map((el) => {
            new Highlights(el);
        });
    }

    if(els._strategy.length){
        [...els._strategy].map((el) => {
            new Strategy(el);
        });
    }

    if(els._governance.length){
        [...els._governance].map((el) => {
            new Governance(el);
        });
    }

    if(els._keyfigures.length){
        [...els._keyfigures].map((el) => {
            new Keyfigures(el);
        });
    }
});